import { Fragment, useEffect, useState } from "react";
import { Link, Route } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import WorkInstructionForm from "./workInstructionForm";
import FilterForm from "./workInstructionFilterForm";
import TransferSelect from "./workInstructionTransfer";
import WorkInstructionDetail from "./workInstructionDetail";
import magnifierImg from "src/img/magnifier.png";
import Footer from "src/components/common/frame/footer";
import { useMyStore } from "src/components/main/mainStore";
import {
    onlyUnique, objAscSort, numberReducer, weeknum,
    myAxios, MyFormData, MyDate, defaultEmptyDateTime,
    scroll, boolAndReducer, changeWeek, testerEmails, projectCategoryColorCode
} from "src/components/common/functions";
import Export from "./workInstructionExport";
//--------------------------------------------------------------------------------------------
export default function WorkInstructions({
    userList,
    history, 
    projects, 
    project, 
    totalHours, 
    setProjectDetailRenderSwitch
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    //--------------------------------------------------------------------------------------------
    const title = "WorkInstructions";
    const defaultFilter = {
        location: "", 
        startTimeMin: "",
        startTimeMax: "",
        endTimeMin: "", 
        endTimeMax: "", 
        travelHoursMin: "",
        travelHoursMax: "", 
        workHoursMin: "",
        workHoursMax: "",
        totalHoursMin: "", 
        totalHoursMax: "", 
        billed: "", 
        //---------------
        workInstructionDescription: "",
        supervisor: "",
        creator: "",
        createdMin: "",
        createdMax: "",
        updater: "",
        updatedMin: "",
        updatedMax: ""
    };
    const [curFilter, setFilter] = useState(defaultFilter);
    const [showFilter, setShowFilterForm] = useState(false);
    const [filterWords, setFilterWords] = useState("");
    //--------------------------------------------------------------------------------------------
    const getTime = e => {
        if(e){
            return e;
        }else{
            return "00:00:00";
        }
    }
    const childRow = e => {
        if(e.target.id) return;
        if(workInstructionId !== e.currentTarget.id){
            history.push(`/Projects/${projectId}/${title}/${e.currentTarget.id}`);
            setTimeout(() => {
                scroll(workInstructionId);   
            }, 200);
        }else{
            history.push(`/Projects/${projectId}`);
            setTimeout(() => {
                scroll(projectId);
            }, 200);
        }
    }
    const createRow = async e => {
        e.preventDefault();
        /*
        if(selectedUsers.length === 0){
            window.alert("Select at least one technician!");
            return;
        }
        */
        const formData = new MyFormData(e.currentTarget);
        const allDay = formData.get("allDay");
        const calendarLocation = formData.get("calendarLocation");
        const startDate = formData.get("startDate");
        const endDate = formData.get("endDate");
        const startTime = formData.get("startTime");
        const endTime = formData.get("endTime");
        const supervisorEmail = formData.get("supervisorEmail");
        if(allDay === null){
            formData.set("allDay", "");
        }
        if(!calendarLocation){
            window.alert("Location is not valid!");
            return;
        }
        if(new Date(startDate.replace(/-/g, "/") + " " + getTime(startTime)) > new Date(endDate.replace(/-/g, "/") + " " + getTime(endTime))){
            window.alert("Start time is greater than end time!");
            return;
        }
        if(startDate !== endDate && !window.confirm("is this a night job?")){
            window.alert("Start date is different from end Date. Please check.");
            return;
        }
        const jobWeek = weeknum(startDate);
        const today = new MyDate();
        const late = ((weeknum(today)) > changeWeek(jobWeek, 1)) || (
            (weeknum(today)) > jobWeek && 
            (
                ((today.getDay() === 2) && today.getHours() >= 12)
                || (today.getDay() > 2 || today.getDay() === 0)
            )
        ); // by Tuesday noon
        if(late){
            if(!window.confirm("Start Date is too old. We will send an email notification to payroll.")) return;
        }
        formData.append("projectManagerEmail", project.projectManagerEmail);
        formData.append("projectHashKey", project.projectHashKey);
        formData.append("projectFolderId", project.projectFolderId);
        if(supervisorEmail){
            const supervisor = userList.filter(u => u.email === supervisorEmail)[0];
            const supervisorName = `${supervisor.userName}`;
            formData.append("supervisorName", supervisorName);
        }
        formData.append("labors", JSON.stringify(selectedUsers.map(user => ({
            email: user.email, 
            laborCategory: user.laborCategory, 
            truckNumber: user.truckNumber,
            trailerNumber: user.trailerNumber,
            perDiem: user.perDiem, 
            name: user.label
        }))));
        formData.append("calendarId", project.calendarId);
        formData.append("projectName", project.projectName);
        formData.append("projectDescription", project.projectDescription);
        //-----------------------------------------------------------
        setShowLoader(true);
        const res = await myAxios("workInstructions/createWorkInstruction.php", formData);
        setShowLoader(false);
        if(!res) return;
        //-----------------------------------------------------------
        setProjectDetailRenderSwitch(s => !s);
        setWorkInstructionRenderSwitch(workInstructionRenderSwitch => !workInstructionRenderSwitch);
        setSelectedUsers([]);
        setCurrentWorkInstruction(null);
        history.push(`/Projects/${projectId}`);
        setTimeout(() => {
            scroll(projectId);
        }, 200);
    }
    const editRow = async e => {
        e.preventDefault();
        /*
        if(selectedUsers.length === 0){
            window.alert("Select at least one labor!");
            return;
        }
        */
        const formData = new MyFormData(e.currentTarget);
        const allDay = formData.get("allDay");
        const startDate = formData.get("startDate");
        const endDate = formData.get("endDate");
        const startTime = formData.get("startTime");
        const endTime = formData.get("endTime");
        const calendarLocation = formData.get("calendarLocation");
        const supervisorEmail = formData.get("supervisorEmail");
        if(allDay === null){
            formData.set("allDay", "");
        }
        if(new Date(startDate.replace(/-/g, "/") + " " + getTime(startTime)) > new Date(endDate.replace(/-/g, "/") + " " + getTime(endTime))){
            window.alert("Start time is greater than end time!");
            return;
        };
        if(!calendarLocation){
            window.alert("Location is not valid!");
            return;
        };
        if(startDate !== endDate && !window.confirm("is this a night job?")){
            window.alert("Start date is different from end Date. Please check.");
            return;
        }
        const isTimeChanged = (
            startDate !== currentWorkInstruction.startTime.substring(0, 10) || 
            endDate !== currentWorkInstruction.endTime.substring(0, 10)
        );
        const cautionStatus = currentWorkLogs.filter(c => c.jobTagSubmitTime !== defaultEmptyDateTime).length;
        let reset = "no";
        if(isTimeChanged && cautionStatus){
            reset = "yes";
        }
        if(reset === "yes" && !window.confirm(
            `this work Instruction already have job tag(s) submitted. You are changing time, this will cause all their works need to be re-submitted. Continue?`
        )) return;
        const jobWeek = weeknum(startDate);
        const today = new MyDate();
        const late = ((weeknum(today)) > changeWeek(jobWeek, 1)) || (
            (weeknum(today)) > jobWeek && 
            (
                ((today.getDay() === 2) && today.getHours() >= 12)
                || (today.getDay() > 2 || today.getDay() === 0)
            )
        ); // by Tuesday noon
        if(late){
            if(!window.confirm("StartDate is too old. We will send an email to payroll.")) return;
        }
        if(
            currentWorkInstruction.startTime.substring(0, 10) !== startDate ||
            currentWorkInstruction.endTime.substring(0, 10) !== endDate
       ){
            if(!window.confirm("You are updating the date. Proceed?")) return;
        }
        formData.append("workInstructionHashKey", currentWorkInstruction.workInstructionHashKey);
        if(supervisorEmail){
            const supervisor = userList.find(u => u.email === supervisorEmail);
            const supervisorName = supervisor.userName;
            formData.append("supervisorName", supervisorName);
        }
        formData.append("labors", JSON.stringify(selectedUsers.map(user => JSON.stringify({
            email: user.email, 
            laborCategory: user.laborCategory, 
            truckNumber: user.truckNumber, 
            trailerNumber: user.trailerNumber,
            perDiem: user.perDiem, 
            name: user.label || user.userName
        }))));
        formData.append("reset", reset);
        //-----------------------------------------------------------
        setShowLoader(true);
        const res = await myAxios("workInstructions/updateWorkInstruction.php", formData);
        setShowLoader(false);
        if(!res) return;
        //-----------------------------------------------------------
        setProjectDetailRenderSwitch(s => !s);
        setWorkInstructionRenderSwitch(workInstructionRenderSwitch => !workInstructionRenderSwitch);
        setCurrentWorkInstructionRenderSwitch(currentWorkInstructionRenderSwitch => !currentWorkInstructionRenderSwitch);
        setSelectedUsers([]);
        setCurrentWorkInstruction(null);
        history.replace(`/Projects/${projectId}`);
    }
    //--------------------------------------------------------------------------------------------
    const [showTransferSelect, setShowTransferSelect] = useState(false);
    const [siteContacts, setSiteContacts] = useState([]);
    const [workInstructions, setWorkInstructions] = useState([]);
    const [workInstructionRenderSwitch, setWorkInstructionRenderSwitch] = useState(true);
    const [currentWorkInstructionRenderSwitch, setCurrentWorkInstructionRenderSwitch] = useState(true);
    const [showLoading, setShowLoading] = useState(false);
    const [loadingWorkLogs, setLoadingWorkLogs] = useState(false);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [currentWorkLogs, setCurrentWorkLogs] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [currentWorkInstruction, setCurrentWorkInstruction] = useState(null);
    //--------------------------------------------------------------------------------------------
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const filterWorkInstructions = workInstructions.filter(u => 
        (curFilter.location?u.location.toLowerCase().indexOf(curFilter.location) > -1:true)
        && (curFilter.startTimeMin?u.startTime >= curFilter.startTimeMin:true)
        && (curFilter.startTimeMax?u.startTime <= curFilter.startTimeMax:true)
        && (curFilter.endTimeMin?u.endTime >= curFilter.endTimeMin:true)
        && (curFilter.endTimeMax?u.endTime <= curFilter.endTimeMax:true)
        && (curFilter.travelHoursMin?u.travelHours >= curFilter.travelHoursMin:true)
        && (curFilter.travelHoursMax?u.travelHours <= curFilter.travelHoursMax:true)
        && (curFilter.workHoursMin?u.workHours >= curFilter.workHoursMin:true)
        && (curFilter.workHoursMax?u.workHours <= curFilter.workHoursMax:true)
        && (curFilter.totalHoursMin?u.totalHours >= curFilter.totalHoursMin:true)
        && (curFilter.totalHoursMax?u.totalHours <= curFilter.totalHoursMax:true)
        && (curFilter.billed?u.billed === curFilter.billed:true)
        //---------------------------
        && (curFilter.workInstructionDescription?u.workInstructionDescription.toLowerCase().indexOf(curFilter.workInstructionDescription) > -1:true)
        && (curFilter.supervisor?curFilter.supervisor === "No"?!u.supervisor:u.supervisor?.replace(/ {2}/g," ") === curFilter.supervisor:true)
        && (curFilter.creator?u.creator?.replace(/ {2}/g," ") === curFilter.creator:true)
        && (curFilter.createdMin?u.dateCreated >= curFilter.createdMin:true)
        && (curFilter.createdMax?u.dateCreated <= curFilter.createdMax:true)
        && (curFilter.updater?u.updater?.replace(/ {2}/g," ") === curFilter.updater:true)
        && (curFilter.updatedMin?u.dateUpdated >= curFilter.updatedMin:true)
        && (curFilter.updatedMax?u.dateUpdated <= curFilter.updatedMax:true)
        && (filterWords.toLowerCase().split(" ").map(f => JSON.stringify(
            Object.values(u)
        ).toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true))
    ).sort((a, b) => objAscSort(a, b, "startTime"));
    const currentWorkInstrucitons = filterWorkInstructions.slice(indexOfFirstItem, indexOfLastItem);
    const pageNumbers = Array.from({length: Math.ceil(filterWorkInstructions.length / itemsPerPage)}, (_, i) => (i + 1));
    const projectId = history.location.pathname.split("/")[2];
    const workInstructionId = history.location.pathname.split("/")[4];
    const workInstructionAction = history.location.pathname.split("/")[5];
    //-----------------------------------------------------------------------------------------
    useEffect(() => {
        /* read all work instructions of the project */
        const projectId = history.location.pathname.split("/")[2];
        let isMounted = true;
        const getWorkInstructionData = async () => {
            setShowLoading(true);
            const formData = new MyFormData();
            formData.append("projectHashKey", projectId);
            if(!projectId) return;
            //-----------------------------------------------------------
            setShowLoader(true);
            const res0 = await myAxios("workInstructions/readBillings.php",  formData);
            setShowLoader(false);
            if(!res0) return;
            //-----------------------------------------------------------
            const billings = res0.data;
            //-----------------------------------------------------------
            setShowLoader(true);
            const res = await myAxios("workInstructions/readWorkInstructions.php",  formData);
            setShowLoader(false);
            if(!res) return;
            //-----------------------------------------------------------
            
            const mainData = res.data.map(w =>({...w, 
                workInstructionFiles: JSON.parse(w.workInstructionFiles),
                billed: billings.filter(billing => billing.startDate <= w.startTime.slice(0, 10) && w.startTime.slice(0, 10) <= billing.endDate).length?"Yes":"",
                travelHours: (totalHours !== null && totalHours.filter(t => t.jobTagSubmitTime !== defaultEmptyDateTime).filter(ww => ww.workInstructionHashKey === w.workInstructionHashKey).length?
                Math.round(totalHours.filter(t => t.jobTagSubmitTime !== defaultEmptyDateTime).filter(ww => ww.workInstructionHashKey === w.workInstructionHashKey).map(d => (
                    (
                        new Date(d.travelEndTime.replace(/-/g, "/")) - 
                        new Date(d.travelStartTime.replace(/-/g, "/"))
                    ) -
                    (
                        new Date(d.workEndTime.replace(/-/g, "/")) - 
                        new Date(d.workStartTime.replace(/-/g, "/"))
                    )
                ) / 3600000)
                .reduce(numberReducer, 0) * 100) / 100:0),
                workHours: (totalHours !== null && totalHours.filter(t => t.jobTagSubmitTime !== defaultEmptyDateTime).filter(ww => ww.workInstructionHashKey === w.workInstructionHashKey).length?
                Math.round(totalHours.filter(t => t.jobTagSubmitTime !== defaultEmptyDateTime).filter(ww => ww.workInstructionHashKey === w.workInstructionHashKey).map(d => (new Date(d.workEndTime.replace(/-/g, "/")) - new Date(d.workStartTime.replace(/-/g, "/"))) / 3600000)
                .reduce(numberReducer, 0) * 100) / 100:0),
                totalHours: (totalHours !== null && totalHours.filter(t => t.jobTagSubmitTime !== defaultEmptyDateTime).filter(ww => ww.workInstructionHashKey === w.workInstructionHashKey).length?
                Math.round(totalHours.filter(t => t.jobTagSubmitTime !== defaultEmptyDateTime).filter(ww => ww.workInstructionHashKey === w.workInstructionHashKey).map(d => (new Date(d.travelEndTime.replace(/-/g, "/")) - new Date(d.travelStartTime.replace(/-/g, "/"))) / 3600000)
                .reduce(numberReducer, 0) * 100) / 100:0),
                laborHoursDetail:
                totalHours !== null && totalHours.length?totalHours.filter(t => t.workInstructionHashKey === w.workInstructionHashKey && t.jobTagSubmitTime !== defaultEmptyDateTime).map(t => t.laborCategory).filter(onlyUnique).sort().map((ddd, key) => 
                [
                    ddd
                    ,
                    (totalHours.filter(t => t.laborCategory === ddd && t.workInstructionHashKey === w.workInstructionHashKey && t.jobTagSubmitTime !== defaultEmptyDateTime).length?
                    Math.round(totalHours.filter(t => t.workInstructionHashKey === w.workInstructionHashKey && t.laborCategory === ddd && t.jobTagSubmitTime !== defaultEmptyDateTime)
                    .map(d => (new Date(d.workEndTime.replace(/-/g, "/")) - new Date(d.workStartTime.replace(/-/g, "/"))) / 3600000)
                    .reduce(numberReducer, 0) * 100) / 100:0)
                    ,
                    (totalHours.filter(t => t.laborCategory === ddd && t.workInstructionHashKey === w.workInstructionHashKey && t.jobTagSubmitTime !== defaultEmptyDateTime).length?
                    Math.round(totalHours.filter(t => t.workInstructionHashKey === w.workInstructionHashKey && t.laborCategory === ddd && t.jobTagSubmitTime !== defaultEmptyDateTime)
                    .map(d => (new Date(d.travelEndTime.replace(/-/g, "/")) -new Date(d.workEndTime.replace(/-/g, "/")) + (new Date(d.workStartTime.replace(/-/g, "/")) - new Date(d.travelStartTime.replace(/-/g, "/")))) / 3600000)
                    .reduce(numberReducer, 0) * 100) / 100:0),
                    (totalHours.filter(t => t.laborCategory === ddd && t.workInstructionHashKey === w.workInstructionHashKey && t.jobTagSubmitTime !== defaultEmptyDateTime).length?
                    Math.round(totalHours.filter(t => t.workInstructionHashKey === w.workInstructionHashKey && t.laborCategory === ddd && t.jobTagSubmitTime !== defaultEmptyDateTime)
                    .map(d => (new Date(d.travelEndTime.replace(/-/g, "/")) - new Date(d.travelStartTime.replace(/-/g, "/"))) / 3600000)
                    .reduce(numberReducer, 0) * 100) / 100:0)
                ]
                ):null
            })).sort((a, b) => objAscSort(a, b, "startTime"));
            if(!isMounted) return;
            setWorkInstructions(mainData);
            setShowLoading(false);
            setShowLoader(false);
            const workInstructionId = history.location.pathname.split("/")[4];
            if(!mainData.filter(w => workInstructionId === w.workInstructionHashKey)[0]){
                switch(workInstructionId){
                    case "Add":
                    case undefined:
                        return
                    default:
                }
                history.replace(`/Projects/${projectId}`);
                return;
            }
            const hashkeys = mainData.map(v => v.workInstructionHashKey);
            setCurrentPage(Math.ceil((hashkeys.indexOf(workInstructionId) + 1) / itemsPerPage));
        }
        getWorkInstructionData();
        return () => {
            isMounted = false;
            setShowLoader(false);
        }
    },[history, totalHours, projectId, workInstructionRenderSwitch, itemsPerPage, setShowLoader]);
    useEffect(() => {
        /* read single work instruction */
        const workInstructionId = history.location.pathname.split("/")[4];
        if(!workInstructions.map(w => w.workInstructionHashKey).includes(workInstructionId) && !["Edit", "Copy", undefined].includes(workInstructionAction)) return;
        let isMounted2 = true;
        const getWorkLogsData = async () => {
            //-----------------------------------------------------------
            const formData = new MyFormData();
            formData.append("organizationHashKey", project.clientName);
            //-----------------------------------------------------------
            setLoadingWorkLogs(true);
            setShowLoader(true);
            const resSiteContacts = await myAxios("common/readSiteContacts.php", formData);
            if(!isMounted2) return;
            setShowLoader(false);
            setLoadingWorkLogs(false);
            if(!resSiteContacts) return;
            //-----------------------------------------------------------
            setSiteContacts(resSiteContacts.data || []);
            //-----------------------------------------------------------
            formData.append("workInstructionHashKey", workInstructionId); 
            //-----------------------------------------------------------
            setLoadingWorkLogs(true);
            setShowLoader(true);
            const resWorkLogs = await myAxios("workInstructions/readWorkLogs.php", formData);
            if(!isMounted2) return;
            setShowLoader(false);
            setLoadingWorkLogs(false);
            if(!resWorkLogs) return;
            //-----------------------------------------------------------
            setCurrentWorkLogs(resWorkLogs.data.map(d => ({...d, workLogFiles: JSON.parse(d.workLogFiles)})));
            setSelectedUsers(resWorkLogs.data.filter(user => user.workLogVoid !== "yes").map(user => ({
                email: user.labor, 
                userName: user.userName?.replace("  ", " "), 
                laborCategory: user.laborCategory, 
                truckNumber: user.truckNumber, 
                trailerNumber: user.trailerNumber,
                perDiem: user.perDiem, 
                teamLead: user.teamLead,
            })));
            setLoadingWorkLogs(false);
            scroll(workInstructionId);
            if(["Edit", "Copy"].includes(history.location.pathname.split("/")[5])){
                const cw = workInstructions.filter(
                    w => workInstructionId === w.workInstructionHashKey
                )[0];
                if(cw !== undefined) setCurrentWorkInstruction(cw);
            }
        }
        getWorkLogsData();
        return () => {
            isMounted2 = false;
            setShowLoader(false);
        }
    },[workInstructions, workInstructionId, workInstructionAction, project.clientName, project.projectHashKey, history, currentWorkInstructionRenderSwitch, setShowLoader])
    //-----------------------------------------------------------------------------------------
    return(
        <div className = "cssTab setDivToXMiddle mb-3 subContentWidth">
            <div className = "cssHeader"  style = {{background: user.userTheme}}>
                <span>
                    Work Instructions
                    <span className = "btn btn-primary py-1 ml-4" onClick = {() => setWorkInstructionRenderSwitch(s => !s)}>↻</span>
                </span>
                <span>
                    <input
                        id = "sub-searchBar"
                        className = "form-control w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                            setCurrentPage(1);
                        }}
                    />
                    <img alt = "" src = {magnifierImg}/>
                </span>
                <span className = "pointer rounded p-1" style = {{
                    backgroundColor: Object.entries(curFilter).filter(([key, value]) => defaultFilter[key] !== value).length?
                    "rgb(0,123,255)"
                    :null
                }} onClick = {() => {setShowFilterForm(true)}}>
                    Filter
                </span>
                {showFilter?
                <FilterForm
                    closeIt = {() => setShowFilterForm(false)}
                    setCurrentPage = {setCurrentPage}
                    curFilter = {curFilter}
                    setFilter = {setFilter}
                    defaultFilter = {defaultFilter}
                    workInstructions = {workInstructions}
                />:null}
                <Export
                    filterWorkInstructions = {filterWorkInstructions}
                />
                {user.projects !== "readOnly"?<>
                <span className = "pointer" onClick = {() => history.push(`/Projects/${projectId}/${title}/Add`)}>Add</span>
                <Route
                    exact
                    path = {`/Projects/${projectId}/${title}/Add`}
                    children = {
                        userList.length !== 0?
                        <WorkInstructionForm
                            closeIt = {()=> {
                                history.replace(`/Projects/${projectId}`); 
                                setSelectedUsers([]);
                                setCurrentWorkInstruction(null);
                                setCurrentWorkInstructionRenderSwitch(s=>!s);
                            }}
                            handleSubmit = {createRow}
                            title = "Add New Work Instruction"
                            keyword = "Add"
                            userList = {userList}
                            showFilesInput = {true}
                            selectedUsers = {selectedUsers}
                            setSelectedUsers = {setSelectedUsers}
                            siteContacts = {siteContacts}
                            project = {project}
                            mnt = {userList.length !== 0}
                            history = {history}
                            workInstruction = {currentWorkInstruction}
                            workLogs = {currentWorkLogs}
                            
                            setCurrentWorkInstruction = {setCurrentWorkInstruction}

                            {...currentWorkInstruction}
                        />:<></>
                    }
                />
                </>:<></>}
            </div>
            <div className = {`cssContent` + (!showLoading && filterWorkInstructions.length?" pb10":"")}>
                {showLoading?<div className = "cssLoading">Loading...</div>:
                !currentWorkInstrucitons.length?<div className = "cssLoading">No Job Scheduled Yet</div>:
                <div className = "table-responsive">
                    <table className = "table">
                        <thead className = "noTableTopBorder">
                            <tr id = "workInstructionTR">
                                <th></th>
                                <th>Category</th>
                                <th>Location</th>
                                <th>Duration</th>
                                <th>Work Hours</th>
                                <th>Travel Hours</th>
                                <th>Total Hours</th>
                                <th>Billed</th>
                                {user.projects !== "readOnly"?
                                <Fragment>
                                {currentWorkInstrucitons.filter(workInstruction => !workInstruction.void).length?
                                <Fragment>
                                <th/>
                                <th/>
                                <th/>
                                <th/>
                                </Fragment>
                                :
                                <Fragment>
                                <th/>
                                {testerEmails.includes(user.email)?
                                <th/>
                                :<></>}
                                </Fragment>}
                                </Fragment>
                                :<></>}
                            </tr>
                        </thead>
                            <tbody>
                            {currentWorkInstrucitons.map((workInstruction, i) => (
                                <Fragment key = {i}>
                                <tr
                                    style = {{
                                        background: workInstruction.void?"gray"
                                        :
                                        ""
                                    }}
                                    id = {workInstruction.workInstructionHashKey}
                                    name = {workInstruction.attachmentFolderId}
                                    onClick = {childRow}
                                    className = "pointer"
                                >
                                    <td className = {workInstructionId === workInstruction.workInstructionHashKey?"showMinus":"showPlus"}></td>
                                    <td
                                        className = "text-white font-weight-bold"
                                        style = {{
                                            backgroundColor: `rgb(${projectCategoryColorCode[workInstruction.category]?.rgb.join(",")})`
                                        }}
                                    >
                                        {workInstruction.category}{workInstruction.subCategory?` - ${workInstruction.subCategory}`:""}
                                    </td>
                                    <td>
                                        <Link to = {`/Map/${workInstruction.workInstructionHashKey}`}>
                                                {workInstruction.location}
                                        </Link>
                                    </td>
                                    {workInstruction.allDay?
                                    <td className = "h5 font-weight-bold">
                                        {workInstruction.startTime.substring(0, 10)}
                                        {workInstruction.startTime.substring(0, 10) === workInstruction.endTime.substring(0, 10)?
                                        null:` ~ ${workInstruction.endTime.substring(0, 10)}`}
                                    </td>
                                    :
                                    <td className = "h5">
                                        <span className = "font-weight-bold">{workInstruction.startTime.substring(0, 10)}</span> 
                                        <span>
                                            {workInstruction.startTime.substring(10, 19)}
                                        </span> 
                                        ~ 
                                        <span className = "font-weight-bold">
                                            {workInstruction.startTime.substring(0, 10) === workInstruction.endTime.substring(0, 10)?
                                            null:workInstruction.endTime.substring(0, 10)}
                                        </span>
                                        <span>
                                            {workInstruction.endTime.substring(10, 19)}
                                        </span>
                                    </td>
                                    }
                                    <td className = "h4">
                                        {workInstruction.workHours}
                                    </td>
                                    <td className = "h4">
                                        {workInstruction.travelHours}
                                    </td>
                                    <td className = "h4">
                                        {workInstruction.totalHours}
                                    </td>
                                    <td className = "h4">
                                        {workInstruction.billed}
                                    </td>
                                    {user.projects !== "readOnly"?
                                    <Fragment>
                                    {workInstruction.void?
                                    <Fragment>
                                    <td>
                                        <span 
                                            id = {workInstruction.workInstructionHashKey + " restore"}
                                            className = "btn btn-success" 
                                            onClick = {async () => {
                                                if(!window.confirm(`are you sure to restore this Work Instruction?`)) return;
                                                const jobWeek = weeknum(workInstruction.startTime.substring(0, 10));
                                                const today = new MyDate();
                                                const late = ((weeknum(today)) > changeWeek(jobWeek, 1)) || (
                                                    (weeknum(today)) > jobWeek && 
                                                    (
                                                        ((today.getDay() === 2) && today.getHours() >= 12)
                                                        || (today.getDay() > 2 || today.getDay() === 0)
                                                    )
                                                ); // by Tuesday noon
                                                if(late){
                                                    if(!window.confirm("StartDate is too old. We will send an email to payroll.")) return;
                                                }
                                                //*************************************************************
                                                const formData = new MyFormData();
                                                formData.append("workInstructionHashKey", workInstruction.workInstructionHashKey);
                                                //-----------------------------------------------------------
                                                setShowLoader(true);
                                                const res = await myAxios("workInstructions/restoreWorkInstruction.php", formData);
                                                setShowLoader(false);
                                                if(!res) return;
                                                //-----------------------------------------------------------
                                                setProjectDetailRenderSwitch(s => !s);
                                                setWorkInstructionRenderSwitch(workInstructionRenderSwitch => !workInstructionRenderSwitch);
                                                setCurrentWorkInstructionRenderSwitch(currentWorkInstructionRenderSwitch => !currentWorkInstructionRenderSwitch);
                                            }}
                                        >
                                            Restore
                                        </span>
                                    </td>
                                    {testerEmails.includes(user.email)?
                                    <td>
                                        <span 
                                            id = {workInstruction.workInstructionHashKey + " deleteForever"}
                                            className = "btn btn-danger" 
                                            onClick = {async() => {
                                                if(!window.confirm(`are you sure to permenently delete this Work Instruction?`)) return;
                                                const jobWeek = weeknum(workInstruction.startTime.substring(0, 10));
                                                const today = new MyDate();
                                                const late = ((weeknum(today)) > changeWeek(jobWeek, 1)) || (
                                                    (weeknum(today)) > jobWeek && 
                                                    (
                                                        ((today.getDay() === 2) && today.getHours() >= 12)
                                                        || (today.getDay() > 2 || today.getDay() === 0)
                                                    )
                                                ); // by Tuesday noon
                                                if(late){
                                                    if(!window.confirm("StartDate is too old. We will send an email to payroll.")) return;;
                                                }
                                                //*************************************************************
                                                const formData = new MyFormData();
                                                formData.append("workInstructionHashKey", workInstruction.workInstructionHashKey);
                                                //-----------------------------------------------------------
                                                setShowLoader(true);
                                                const res = await myAxios("workInstructions/deleteWorkInstruction.php", formData);
                                                setShowLoader(false);
                                                if(!res) return;
                                                //-----------------------------------------------------------
                                                setProjectDetailRenderSwitch(s => !s);
                                                setWorkInstructionRenderSwitch(workInstructionRenderSwitch => !workInstructionRenderSwitch);
                                                setCurrentWorkInstructionRenderSwitch(currentWorkInstructionRenderSwitch => !currentWorkInstructionRenderSwitch);
                                            }}
                                        >
                                            Delete Forever
                                        </span>
                                    </td>
                                    :<></>}
                                    {currentWorkInstrucitons.filter(workInstruction => !workInstruction.void).length?<>
                                    <td/>
                                    <td/>
                                    <td/>
                                    </>:<></>}
                                    </Fragment>
                                    :
                                    <Fragment>
                                    <td>
                                        <span id = {workInstruction.workInstructionHashKey + " edit"} className = "btn btn-primary" onClick = {() => {
                                            history.push(`/Projects/${projectId}/${title}/${workInstruction.workInstructionHashKey}/Edit`);
                                        }}>
                                            Edit
                                        </span>
                                    </td>
                                    <td>
                                        <span id = {workInstruction.workInstructionHashKey + " copy"} className = "btn btn-warning" onClick = {() => {
                                            history.push(`/Projects/${projectId}/${title}/${workInstruction.workInstructionHashKey}/Copy`);
                                        }}>
                                            Copy
                                        </span>
                                    </td>
                                    <td>
                                        <span 
                                            id = {workInstruction.workInstructionHashKey + " void"}
                                            className = "btn btn-dark" 
                                            onClick = {async() => {
                                                if(!window.confirm(`are you sure to void this Work Instruction?`)) return;
                                                let voidReason = window.prompt("reason to void:");
                                                if(voidReason === null) return;
                                                while(voidReason === ""){
                                                    window.alert("Reason is required to void.");
                                                    voidReason = window.prompt("reason to void:");
                                                    if(voidReason === null) return;
                                                }
                                                const jobWeek = weeknum(workInstruction.startTime.substring(0, 10));
                                                const today = new MyDate();
                                                const late = ((weeknum(today)) > changeWeek(jobWeek, 1)) || (
                                                    (weeknum(today)) > jobWeek && 
                                                    (
                                                        ((today.getDay() === 2) && today.getHours() >= 12)
                                                        || (today.getDay() > 2 || today.getDay() === 0)
                                                    )
                                                ); // by Tuesday noon
                                                if(late){
                                                    if(!window.confirm("StartDate is too old. We will send an email to payroll.")) return;
                                                }
                                                //*************************************************************
                                                const formData = new MyFormData();
                                                formData.append("workInstructionHashKey", workInstruction.workInstructionHashKey);
                                                formData.append("voidReason", voidReason);
                                                //----------------------------------------------------
                                                setShowLoader(true);
                                                const res = await myAxios("workInstructions/voidWorkInstruction.php", formData);
                                                setShowLoader(false);
                                                if(!res) return;
                                                //----------------------------------------------------
                                                setProjectDetailRenderSwitch(s => !s);
                                                setWorkInstructionRenderSwitch(workInstructionRenderSwitch => !workInstructionRenderSwitch);
                                                setCurrentWorkInstructionRenderSwitch(currentWorkInstructionRenderSwitch => !currentWorkInstructionRenderSwitch);
                                            }}
                                        >
                                            Void
                                        </span>
                                    </td>
                                    <td>
                                        <span 
                                            id = {workInstruction.workInstructionHashKey + " transfer"}
                                            className = "btn btn-info" 
                                            onClick = {() => {
                                                setShowTransferSelect(true);
                                                setCurrentWorkInstruction(workInstruction);
                                            }}
                                        >
                                            Transfer
                                        </span>
                                        {showTransferSelect?
                                        <TransferSelect
                                            closeIt = {() => setShowTransferSelect(false)}
                                            projects = {projects}
                                            project = {project}
                                            projectId = {projectId}
                                            
                                            setShowTransferSelect = {setShowTransferSelect}
                                            setSelectedUsers = {setSelectedUsers}
                                            history = {history}
                                            
                                            currentWorkInstruction = {currentWorkInstruction}
                                            setCurrentWorkInstruction = {setCurrentWorkInstruction}

                                            setCurrentWorkInstructionRenderSwitch = {setCurrentWorkInstructionRenderSwitch}
                                            setWorkInstructionRenderSwitch = {setWorkInstructionRenderSwitch}
                                        />:null}
                                    </td>
                                    </Fragment>
                                    }
                                    </Fragment>
                                    :<></>}
                                </tr>
                                <Route path = {`/Projects/${projectId}/${title}/${workInstruction.workInstructionHashKey}`} children = {
                                <tr className = "noBorderTop">
                                    <td colSpan = {100}>
                                        <WorkInstructionDetail
                                            title = {title}
                                            totalHours = {totalHours}
                                            siteContacts = {siteContacts}
                                            project = {project}
                                            projectId = {projectId}
                                            setCurrentWorkInstruction = {setCurrentWorkInstruction}
                                            setWorkInstructions = {setWorkInstructions}
                                            workInstructions = {workInstructions}
                                            workInstruction = {workInstruction}
                                            workInstructionId = {workInstructionId}
                                            currentWorkLogs = {currentWorkLogs}
                                            setCurrentWorkLogs = {setCurrentWorkLogs}

                                            loadingWorkLogs = {loadingWorkLogs}
                                        />
                                    </td>
                                </tr>
                                }/>
                                </Fragment>
                            ))}
                        </tbody>
                    </table>
                    <Route
                        exact
                        path = {`/Projects/${projectId}/${title}/${workInstructionId}/Edit`}
                        children = {
                            currentWorkInstruction !== null?
                            <WorkInstructionForm
                                closeIt = {() => {
                                    history.replace(`/Projects/${projectId}`);
                                    setSelectedUsers([]);
                                    setCurrentWorkInstruction(null);
                                    setCurrentWorkInstructionRenderSwitch(s=>!s);
                                }}
                                handleSubmit = {editRow}
                                title = "Edit Work Instruction"
                                keyword = "Edit"
                                userList = {userList}
                                showFilesInput = {false}
                                selectedUsers = {selectedUsers}
                                setSelectedUsers = {setSelectedUsers}
                                siteContacts = {siteContacts}
                                project = {project}
                                mnt = {currentWorkInstruction !== null}
                                history = {history}
                                workInstruction = {currentWorkInstruction}
                                workLogs = {currentWorkLogs}

                                setCurrentWorkInstruction = {setCurrentWorkInstruction}

                                {...currentWorkInstruction}
                            />:<></>
                        }
                    />
                    
                    <Route
                        exact
                        path = {`/Projects/${projectId}/${title}/${workInstructionId}/Copy`}
                        children = {
                            currentWorkInstruction !== null?
                            <WorkInstructionForm
                                closeIt = {() => {
                                    history.replace(`/Projects/${projectId}`);
                                    setSelectedUsers([]);
                                    setCurrentWorkInstruction(null);
                                    setCurrentWorkInstructionRenderSwitch(s=>!s);
                                }}
                                handleSubmit = {createRow}
                                title = "Copy Work Instruction"
                                keyword = "Copy"
                                userList = {userList}
                                showFilesInput = {true}
                                selectedUsers = {selectedUsers}
                                setSelectedUsers = {setSelectedUsers}
                                siteContacts = {siteContacts}
                                project = {project}
                                mnt = {userList.length !== 0}
                                history = {history}
                                workInstruction = {currentWorkInstruction}
                                workLogs = {currentWorkLogs}

                                setCurrentWorkInstruction = {setCurrentWorkInstruction}

                                {...currentWorkInstruction}

                                
                            />:<></>
                        }
                    />
                </div>}
                {!showLoading && filterWorkInstructions.length?
                <Footer
                    pageSelectId = "workinstructions"
                    length = {filterWorkInstructions.length}
                    pageNumbers = {pageNumbers}

                    currentPage = {currentPage}
                    setCurrentPage = {setCurrentPage}
                    itemsPerPage = {itemsPerPage}
                    setItemsPerPage = {setItemsPerPage}

                    parentId = {"workInstructionTR"}
                />
                :null}
            </div>
        </div>
    )
}